export function getScrollParent(
  node: HTMLElement | null
): HTMLElement | undefined {
  if (!node) return undefined;
  if (node.scrollHeight > node.clientHeight) return node;
  return getScrollParent(node.parentNode as HTMLElement);
}

export function getParent(
  node: HTMLElement | null,
  selector: string
): Element | undefined {
  if (!node) return undefined;
  const parents = document.querySelectorAll(selector);
  return [...parents].find((parent) => parent.contains(node));
}

export function hasParent(node: HTMLElement | null, selector: string): boolean {
  return Boolean(getParent(node, selector));
}

export const downloadPDF = async (
  orientation?: "portrait" | "landscape"
): Promise<void> => {
  const { default: html2pdf } = await import("html2pdf.js");
  try {
    const element: HTMLElement | null =
      document.querySelector("[data-pdfdownload]");
    if (!element) {
      throw new Error("Element with data-pdfdownload not found");
    }

    const filename = element.dataset.pdfdownload;
    if (!filename) {
      throw new Error("data-pdfdownload attribute value is empty");
    }

    await html2pdf()
      .set({
        margin: 1,
        filename: `${filename}.pdf`,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: {
          scale: 2,
          useCORS: true,
          logging: false,
        },
        jsPDF: {
          unit: "in",
          format: "letter",
          orientation: orientation || "landscape",
          hotfixes: ["px_scaling"],
        },
        pagebreak: { mode: ["avoid-all", "css", "legacy"] },
        enableLinks: true,
      })
      .from(element as HTMLElement)
      .save();
  } catch (error) {
    console.error("Error generating PDF:", error);
    throw error;
  }
};
